import axios from 'axios';

// Produktion: gleiche Domain wie SPA → /api. Lokal: CRA-Proxy (setupProxy.js) leitet /api an :8000.
const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

// CSRF-Cookie aus dem Browser auslesen (Django setzt es via GET /api/auth/csrf/)
function getCsrfToken() {
  const match = document.cookie.match(/(?:^|; )csrftoken=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
}

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // Session-Cookie mitsenden
  headers: {
    'Content-Type': 'application/json',
  },
});

// CSRF-Token bei allen schreibenden Requests automatisch anhängen
api.interceptors.request.use((config) => {
  if (['post', 'put', 'patch', 'delete'].includes(config.method)) {
    const token = getCsrfToken();
    if (token) config.headers['X-CSRFToken'] = token;
  }
  return config;
});

// Bei 401 → zur Login-Seite weiterleiten (außer wenn wir gerade /auth/ anfragen)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Kein Reload – Endlosschleife vermeiden; SiteAccessGate über AuthContext/bootstrap.
    if (error.response?.status === 403 && error.response?.data?.code === 'site_access_required') {
      return Promise.reject(error);
    }
    if (
      error.response?.status === 401 &&
      !error.config.url.includes('/auth/')
    ) {
      window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);

// Auth API
export const authAPI = {
  config: () => api.get('/auth/config/'),
  getCsrf: () => api.get('/auth/csrf/'),
  siteAccessStatus: () => api.get('/auth/site-access/'),
  siteAccessUnlock: (password) => api.post('/auth/site-access/', { password }),
  me: () => api.get('/auth/me/'),
  login: (email, password) => api.post('/auth/login/', { email, password }),
  logout: () => api.post('/auth/logout/'),
  entraStart: () => api.post('/auth/entra/start/'),
  entraComplete: (code, state) => api.post('/auth/entra/complete/', { code, state }),
  inviteCreate: (email) => api.post('/auth/invite/', { email }),
  inviteVerify: (token) => api.get('/auth/invite/verify/', { params: { token } }),
  inviteAccept: (token, password, first_name, last_name) =>
    api.post('/auth/invite/accept/', { token, password, first_name, last_name }),
};

export const resourceAPI = {
  getAccountManager: () => api.get('/resources/account-manager/'),
  askExpertQuestion: (question) => api.post('/resources/ask-expert/', { question }),
};

/*
 * Legacy-Ticketing/Projekt/Reporting-APIs deaktiviert.
 * Der aktuelle Portalumfang unter http://localhost:3000/ nutzt diese Endpunkte nicht.
 *
 * Bei späterer Reaktivierung können die bisherigen API-Wrapper hier wieder aktiviert werden.
 */

export default api; 